import type { SWRConfiguration } from 'swr'
import useSWR from 'swr'

import { getAdminLists } from '../api/adminApi'
import { SchoolLists } from '../types'

export default function useAdminLists(options?: SWRConfiguration) {
  return useSWR<SchoolLists[], Error>('adminLists', getAdminLists, options)
}
